var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewChat2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3H3C1.89543 3 1 3.89543 1 5V17.5C1 18.6046 1.89543 19.5 3 19.5H14.5C15.6046 19.5 16.5 18.6046 16.5 17.5V10",
    stroke: "#2A2A2A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2167 5.01667L14.9833 5.78333L7.43333 13.3333H6.66667V12.5667L14.2167 5.01667ZM17.2167 0C17.0083 0 16.7917 0.0833333 16.6333 0.241667L15.1083 1.76667L18.2333 4.89167L19.7583 3.36667C19.8356 3.28957 19.8969 3.198 19.9387 3.09719C19.9805 2.99638 20.002 2.88831 20.002 2.77917C20.002 2.67003 19.9805 2.56196 19.9387 2.46115C19.8969 2.36034 19.8356 2.26876 19.7583 2.19167L17.8083 0.241667C17.6417 0.075 17.4333 0 17.2167 0ZM14.2167 2.65833L5 11.875V15H8.125L17.3417 5.78333L14.2167 2.65833Z",
    fill: "#2A2A2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewChat2);
export default __webpack_public_path__ + "static/media/new_chat2.818bc9c3c339ff1407cbe0a7f1aa4c03.svg";
export { ForwardRef as ReactComponent };